// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c293eea3","239":"49f289cc","453":"af205ec6","560":"b2202255","732":"3a987d0b","977":"3d215627"}[chunkId] + ".chunk.js";
};